import React from "react";
import { Button, Tooltip, message } from "antd";
import { FaTrash, FaEdit, FaFolderPlus, FaChalkboardTeacher } from "react-icons/fa";
import PermissionGuard from "../../Guards/PermissionGuard";
import { PERMISSIONS } from "../../../constants/permissions";

const ExamBankActions = ({
    record,
    onEdit,
    onDelete,
    onAddChild,
    onManageExams,
    showAddChild = true,
    showManageExams = true,
}) => {
    return (
        <div className="flex gap-2 justify-center">
            <PermissionGuard permission={PERMISSIONS.EXAMBANKS_EDIT}>
                <Tooltip title="ویرایش">
                    <Button
                        type="link"
                        className="text-blue-500"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEdit(record);
                        }}
                        icon={<FaEdit size={18} />}
                    />
                </Tooltip>
            </PermissionGuard>
            <PermissionGuard permission={PERMISSIONS.EXAMBANKS_DELETE}>
                <Tooltip title="حذف">
                    <Button
                        type="link"
                        className="text-red-500"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete(record.Id || record.id);
                        }}
                        icon={<FaTrash size={18} color="#980000" />}
                    />
                </Tooltip>
            </PermissionGuard>
        </div>
    );
};

export default ExamBankActions;